export function getTestId(elementName) {
    return `toast${elementName}`;
}
